import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { VideoButton } from 'yankees-react-utils';
import { VideoPlayerModal } from './VideoPlayer';

const VideoPlaylistButton = ({ modalContainer, icon, text, color, textColor, showCameraIcon, playlist, size, ...rest }) => {
    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    return (
        <>
            <VideoButton
                onClick={() => setShowVideoPlayer(true)}
                color={color}
                icon={icon}
                text={text}
                textColor={textColor}
                showCameraIcon={showCameraIcon}
                size={size}
                {...rest}
            />
            <VideoPlayerModal
                playlist={playlist}
                show={showVideoPlayer}
                onHide={() => setShowVideoPlayer(false)}
                container={modalContainer}
                hideFrameGrab
                {...rest}
            />
        </>
    );
};

VideoPlaylistButton.propTypes = {
    modalContainer: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    icon: PropTypes.string,
    color: PropTypes.string,
    text: PropTypes.string || PropTypes.number,
    textColor: PropTypes.string,
    showCameraIcon: PropTypes.bool,
    playlist: PropTypes.arrayOf(PropTypes.object).isRequired,
    size: PropTypes.string,
};
VideoPlaylistButton.defaultProps = {
    icon: undefined,
    color: undefined,
    text: undefined,
    textColor: undefined,
    showCameraIcon: true,
    modalContainer: undefined,
    size: undefined,
};

export default VideoPlaylistButton;
